module.exports = __webpack_public_path__ + "static/media/About Us Picture 06.5db9aed0.jpg";